/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import StarRatingComponent from "react-star-rating-component";
import { WingBlank } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import { FaEdit } from "react-icons/fa";
import ReviewListing from "../../../components/ReviewListing";
import LoadingIndicator from "../../../components/LoadingIndicator";
import Theme from "../../../utils/Theme";
import "./index.css";

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const StyledRatingContainer = styled.div`
  padding: 15px;
  font-size: 0.8em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledScore = styled.span`
  margin-left: 8px;
  color: grey;
  font-size: 1.05em;
`;

const StyledReviewButton = styled.div`
  cursor: pointer;
  padding: 15px;
  display: flex;
  flex-direction: row;
  background: white;
  justify-content: center;
  align-items: center;
  color: ${Theme.TertiaryColor};
  border: 0.5px solid ${Theme.TertiaryColor};
  font-size: 0.9em;
  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }
`;

class ReviewSection extends Component {
  constructor(props) {
    super(props);
  }

  getHeader = () => {
    const { review } = this.props;
    const rating = review && review.rating ? review.rating : 0;
    const count = review && review.count ? review.count : 0;

    return (
      <StyledRatingContainer>
        <StarRatingComponent
          name={"productItemRating"}
          editing={false}
          starCount={5}
          value={rating}
          starColor={Theme.PrimaryColor}
          emptyStarColor={"lightgrey"}
        />
        <StyledScore>{count}</StyledScore>
      </StyledRatingContainer>
    );
  };

  getLoadingIndicator = () => {
    const { isLoading, hideLoading } = this.props;

    if (hideLoading) {
      return null;
    }

    if (!isLoading) {
      return null;
    }

    return <LoadingIndicator />;
  };

  render() {
    const {
      reviews,
      history,
      isLoading,
      onEndReached,
      isReviewable,
      onPressWriteReview
    } = this.props;

    return (
      <StyledContentContainer>
        {this.getLoadingIndicator()}
        <ReviewListing
          {...this.props}
          items={reviews}
          renderHeader={() => this.getHeader()}
          showFooterLoading={isLoading && reviews && reviews.length > 0}
          onEndReached={onEndReached}
        />
        {isReviewable ? (
          <StyledReviewButton
            onClick={() => onPressWriteReview && onPressWriteReview()}
          >
            <FaEdit size={"1.3em"} />
            <WingBlank size={"sm"} />
            <FormattedMessage
              id="product.tab.review.write.review"
              defaultMessage="Write a review"
              description="Write a review title"
            />
          </StyledReviewButton>
        ) : null}
      </StyledContentContainer>
    );
  }
}

ReviewSection.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  reviews: PropTypes.array,
  isReviewable: PropTypes.bool,
  isLoading: PropTypes.bool,
  hideLoading: PropTypes.bool,
  onEndReached: PropTypes.bool,
  onPressWriteReview: PropTypes.func
};

export default ReviewSection;



// WEBPACK FOOTER //
// ./src/containers/ProductPage/ReviewSection/index.js